import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import ColorsContext from './ColorsContext';
import RegionHeader from './RegionHeader';
import { getDefaultDate, setLongmonyr } from './routines';
import ISLTable from './ISLTable'; 

function KbdiStation(props) {
    const monyr = props.date ? props.date : getDefaultDate();
    const areaType = props.areaType;
	const [ stationData, setStationData ] = useState(null);
    const [ datestr, setDatestr ] = useState();
    const { levelColors } = useContext(ColorsContext);

    const dataFileNameBase = areaType === "region" ? "station_kbdi_" : `station_${areaType}_kbdi_`;
    const dataFileName = (props.match ? ".." : ".") + "/data/" + dataFileNameBase + monyr + ".json";

    const kbdiTitle = "KBDI";

    const buttontext = "Map View";
    const buttonValue = monyr === 'daily' ? 'kbdidlyregion' : (monyr.length === 7 ? (areaType === 'region' ? "kbdiregion" : `kbdi${areaType}`) : (areaType === 'region' ? "kbdiwkregion" : `kbdiwk${areaType}`));

    let longmonyr = monyr !== 'daily' ? setLongmonyr(monyr) : null;

    
    let droughtRegions = [
        "Western",
        "Connecticut River",
        "Central",
        "Northeast",
        "Southeast",
        "Cape Cod",
        "Islands"
    ];

    const basins = [
		"Blackstone",
		"Boston Harbor",
		"Buzzards Bay",
		"Cape Cod",
		"Charles",
		"Chicopee",
		"Connecticut",
		"Deerfield",
		"Farmington",
		"French",
		"Housatonic",
		"Hudson",
		"Ipswich",
		"Islands",
		"Merrimack",
		"Millers",
		"Narragansett Bay",
		"Nashua",
		"North Coastal",
		"Parker",
		"Quinebaug",
		"Shawsheen",
		"South Coastal",
		"SuAsCo",
		"Taunton",
		"Ten Mile",
		"Westfield"
	];

    const counties = [
        "Barnstable",
        "Berkshire",
        "Bristol",
        "Dukes",
        "Essex",
        "Franklin",
        "Hampden",
        "Hampshire",
        "Middlesex",
        "Nantucket",
        "Norfolk",
        "Plymouth",
        "Suffolk",
        "Worcester"
    ];

    var droughtAreas;
    switch (areaType) {
        case 'region':
            droughtAreas = droughtRegions;
            break;
        case 'basin':
            droughtAreas = basins;
            break;
        case 'county':
            droughtAreas = counties;
            break;
        default:
            console.log(`Bad areaType selection - ${areaType}`);
            droughtAreas = droughtRegions;
    }
        
    const getStnData = () => { 
		axios.get(dataFileName)
		.then(results => {
            setStationData(results.data.data);
            if (monyr === 'daily') {
                longmonyr = setLongmonyr(results.data.data_thru);
            }
            setDatestr(longmonyr);
		})
		.catch(err => {
			console.log("Station Data Error: " + err);
		});
	}

	useEffect(() => {
		getStnData();
		 // eslint-disable-next-line
	}, [])

	return (
        <>
        	<RegionHeader
				title={"KBDI"}
				buttontext={buttontext}
				buttonValue={buttonValue}
				handleButtonClick={props.handleButtonClick}
			/>
            {stationData &&
                <div style={{overflowX:"auto"}}>
                    <table className="pcpnTable-container">
                        <caption>  
                            {datestr} {kbdiTitle}<br />
                            <ISLTable />
                        </caption>      
                        <thead>
                            <tr>
                                <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
                               <th scope="col">Station</th>
                                <th scope="col">{kbdiTitle}</th>
                            </tr>
                        </thead>
                        <tbody className="stnTable-container">
                            {droughtAreas.map((rd, i) => (                           
                                <React.Fragment key={"f"+i}>
                                    {Object.keys(stationData[rd]).map((stn, j) => (
                                        <tr key={i+"stn"+j}>
                                            <td>{rd.replace("Connecticut River","CTRV")}</td>
                                            <td>{stationData[rd][stn].name}</td>
                                            <td style={{
                                                backgroundColor: stationData[rd][stn] ? levelColors[stationData[rd][stn].level] : "white",
                                                color: stationData[rd][stn] && stationData[rd][stn].level === 4 ? "white" : "black"
                                            }}>
                                                {stationData[rd][stn] ? stationData[rd][stn].kbdi : "NA"}
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </>
	);
}

export default KbdiStation
